import styled from 'styled-components'

export const BrandWrapper = styled.div`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.primary};
  width: 140px;
  height: 57px;
  cursor: pointer;

  svg {
    width: 100%;
    height: auto;
  }
`
